import { mergeToNewObject } from '../../../util/object.helpers'
import { TOP_UP_MILES_ACTION } from '../../../constants/actions'
import { buildErrorMessage } from '../../../util/reducer.helpers'
import { formatValidator } from '../../../util/validation.helpers'

export const topUpMilesProfile = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case TOP_UP_MILES_ACTION.CHANGE_STATE:
      return mergeToNewObject(state, { [payload.property]: payload.value })

    case TOP_UP_MILES_ACTION.RESET_STATE:
      return {
        milesValue: '',
        loading: false,
        isProcessing: false,
        error: {},
        success: {}
      }

    case TOP_UP_MILES_ACTION.GET_MILES:
      return mergeToNewObject(state, {
        loading: true
      })

    case TOP_UP_MILES_ACTION.GET_MILES_SUCCESS:
      return mergeToNewObject(state, {
        loading: false,
        miles: payload.milesBalance || 0
      })

    case TOP_UP_MILES_ACTION.GET_MILES_FAILED:
      return mergeToNewObject(state, {
        loading: false
      })

    case TOP_UP_MILES_ACTION.SUBMIT_TOP_UP:
      return mergeToNewObject(state, {
        isProcessing: true
      })

    case TOP_UP_MILES_ACTION.SUBMIT_TOP_UP_SUCCESS:
      return mergeToNewObject(state, {
        isProcessing: false,
        milesValue: '',
        success: {
          milesValue: formatValidator('exchange.top-up-miles-success')
        }
      })

    case TOP_UP_MILES_ACTION.SUBMIT_TOP_UP_FAILED:
      return mergeToNewObject(
        state,
        {
          isProcessing: false
        },
        extractErrorMessage(payload)
      )

    default:
      return state
  }
}

const INITIAL_STATE = {
  miles: 0,
  milesValue: '',
  loading: false,
  isProcessing: false,
  error: {},
  success: {}
}

export const TOP_UP_MILES_DISPATCH = {
  MILES_VALUE: 'milesValue',

  ERROR: 'error',
  SUCCESS: 'success'
}

const extractErrorMessage = (payload) => {
  return {
    error: {
      milesValue: buildErrorMessage(payload)
    }
  }
}
